/**
 * C3 — identidade da sessão da clínica. Não depende de nada (nem de `@/core`, nem de Vue).
 *
 * Existe separado do `SessionUser` de C2 porque o `SessionUser` vendorizado fixa
 * `persona: 'operacional'` como literal; o núcleo compartilhado guarda só token e expiração
 * (que é o seu papel de segurança), e a identidade de negócio da clínica mora aqui.
 */

/** Persona desta SPA. É a mesma string aceita pelo BFF em `POST /auth/session`. */
export const CLINIC_PERSONA = 'clinicas';

/** Unidade (clínica) em que o usuário pode atuar — `Companies` de `GET /auth/me`. */
export interface ClinicCompany {
  readonly id: string;
  readonly name: string;
  readonly identificationCode: string;
  readonly city: string | undefined;
  readonly state: string | undefined;
  readonly isOwner: boolean;
}

export interface ClinicUser {
  readonly id: string;
  readonly name: string;
  readonly email: string;
  readonly active: boolean;
  readonly permissions: readonly string[];
  /** Unidade ativa. Multi-clínica recria as stores quando isto muda. */
  readonly activeCompanyId: string | undefined;
  readonly companies: readonly ClinicCompany[];
}

/** Iniciais para o `.avatar` do cabeçalho (`HB` em "Helena Braga", no protótipo). */
export function userInitials(user: ClinicUser | null): string {
  if (user === null) return '·';
  const parts = user.name.trim().split(/\s+/u).filter((part) => part.length > 0);
  const first = parts[0]?.charAt(0) ?? '';
  const last = parts.length > 1 ? (parts[parts.length - 1]?.charAt(0) ?? '') : '';
  return `${first}${last}`.toUpperCase() || '·';
}

/** Primeiro nome — o cabeçalho do Início cumprimenta pelo primeiro nome ("Olá, Helena"). */
export function firstName(user: ClinicUser | null): string | null {
  if (user === null) return null;
  return user.name.trim().split(/\s+/u)[0] ?? null;
}
